import { useEffect } from "react";
import { authService } from "../../auth/authService";

export default function SilentRefresh() {
  useEffect(() => {
    authService.userManager.signinSilentCallback().catch(() => {
      // No UI needed for silent renew.
    });
  }, []);

  return <div />;
}
